export default __webpack_public_path__ + "7a1f8019567b1e0db1541abd5d9068e2f0457eeb6d612c11c922a6bbcd2c3b62.png";